// 商城唤起分享组件
export function scSharePanel(shareInfo) {
  let shareData = genShareInfo(shareInfo)
  try {
    // 商城app 唤起分享组件
    window.jdShare.callSharePane(shareData)
  } catch (e) { }
}

function genShareInfo(shareInfo) {
  let {
    link,
    imgUrl,
    title,
    desc,
    friendesc,
  } = shareInfo

  let enLink = encodeURIComponent(link)
  enLink = encodeURIComponent(enLink);
  let shareLink = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx64b24636db985046&redirect_uri=http%3a%2f%2fjrappgw.jd.com%2fwxjdissue%2fjdissueWX%2fview%3ftype%3dsubjectPage%26url%3d${enLink}&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect`

  let shareData = {
    title: title,
    content: desc,
    url: shareLink,
    img: imgUrl,
    channel: 'Wxfriends,Wxmoments,QQfriends,QQzone,Moreshare',
    callback: null
  }

  return shareData
}



// WEBPACK FOOTER //
// ./src/public/shareJdsc.js